import { render, staticRenderFns } from "./GuiaRomana.vue?vue&type=template&id=719d0282&"
import script from "./GuiaRomana.vue?vue&type=script&lang=js&"
export * from "./GuiaRomana.vue?vue&type=script&lang=js&"
import style0 from "./GuiaRomana.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports